"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMoneyFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M3 21h26v2H3zM3 25h26v2H3z" }),
        React.createElement("circle", { cx: 16, cy: 12, r: 2 }),
        React.createElement("path", { d: "M3 5v14h26V5zm5 8a1 1 0 111-1 1 1 0 01-1 1zm8 3a4 4 0 114-4 4 4 0 01-4 4zm8-3a1 1 0 111-1 1 1 0 01-1 1z" })));
}
exports.default = SvgMoneyFilled;
//# sourceMappingURL=MoneyFilled.js.map